<template>
  <div class="h-full flex flex-col">
    <div class="toprow ui two column grid">
      <div class="column">
        <h1 class="text-xl flex-grow-0">速记本</h1>
      </div>
      <div class="column text-right text-gray-600">
        <span v-if="show_history" class="font-bold text-gray-700">
          {{ format_time(show_history.time) }}
          历史版本【只读】
        </span>
        <span v-else-if="saving">
          <div class="ui tiny active inline loader"></div>
          正在保存...
        </span>
        <span v-else-if="in_sync">
          已同步
          <span v-if="last_save">
            , {{ format_time_ms(last_save) }}
          </span>
        </span>
        <span v-else>
          <span v-if="last_save">
            最近保存: {{ format_time_ms(last_save) }}
          </span>
          <a class="cursor-pointer text-blue-500" @click="save">立即保存</a>
        </span>
        <a class="ui small teal icon history button" :class="{basic:history==null}"
           data-tooltip="历史版本" data-position="bottom center"
           :disabled="history_loading"
           @click="history?close_history():load_history()">
          <i class="history icon"></i>
        </a>
      </div>
    </div>
    <hr class="my-4 flex-grow-0">
    <div class="flex-grow border-solid border-gray-400 overflow-y-auto">
      <Placeholder v-if="loading" />
      <div class="" v-else>
        <div class="history mr-10" v-if="history">
          <div class="ui segment">
            <div class="text-right">
              <button class="ui tiny basic red icon button" data-tooltip="关闭" data-position="bottom center" @click="close_history">
                <i class="times icon"></i>
              </button>
            </div>
            <div>
              <a @click="history_current">
                <i class="teal circle icon" :class="{outline:show_history}"></i>
                当前状态
              </a>
            </div>
            <div v-for="(h, index) in history.entries" :key="index">
              <a :class="{active:h==show_history}" @click="goto_history(h)">
                <i class="teal circle icon" :class="{outline:h!=show_history}"></i>
                {{ format_time(h.time) }}
              </a>
            </div>
          </div>
        </div>
        <div class="editor">
          <Placeholder class="mt-4" v-if="history_loading" />
          <div class="history data" v-else-if="show_history" v-html="history_data">
          </div>
          <DocEditor v-else id="editor"
                     placeholder="点击这里开始输入，你的笔记会自动保存！"
                     v-model="data"
                     class="border-solid h-full"
                     />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocEditor from './editor';
import Placeholder from './placeholder';

export default {
  name: 'Notes',
  props: [],
  components: {
    DocEditor,
    Placeholder,
  },
  data: function () {
    return {
      loading: true,
      saving: false,
      last_save: 0,
      last_data: null,
      data: '',
      history: null,
      show_history: null,
      history_data: null,
      history_loading: false,
      history_cache: new Map(),
    };
  },
  computed: {
    in_sync() {
      return this.last_data == this.data;
    },
    space() {
      return this.$store.state.space;
    },
  },
  methods: {
    async save() {
      if (this.saving || this.loading) {
        return;
      }
      if (this.last_data === null) {
        return;
      }
      if (this.last_data == this.data) {
        return;
      }
      this.saving = true;
      var data = { data: this.data };
      try {
        await this.$store.dispatch("save_notes", data);
        this.last_save = Date.now();
        this.last_data = this.data;
      } catch (e) {
        this.show_error(e);
      } finally {
        this.saving = false;
      }
    },
    async load_history() {
      this.history_loading = true;
      await this.save();
      var r = await this.client.fetch_space_history(this.space.name,
                                                    0, 0, 0, "/.mods/notes.json");
      this.history = r;
      this.history_loading = false;
    },
    async goto_history(h) {
      var data = this.history_cache.get(h.root);
      if (data == null) {
        this.history_loading = true;
        var sp = await this.client.open_space(this.space.name,
                this.$store.state.default_passphrase, h.root);
        var d = await sp.read_json_file("/.mods/notes.json");
        data = d.data;
        this.history_cache.set(h.root, data);
        this.history_loading = false;
      }
      this.history_data = data;
      this.show_history = h;
    },
    history_current() {
      this.history_data = null;
      this.show_history = null;
    },
    close_history() {
      this.history = false;
      this.history_data = null;
      this.show_history = null;
    },
  },
  mounted() {
    this.$store.dispatch('notes_init').then(() => {
      if (this.$store.state.notes) {
        this.data = this.$store.state.notes.data || "";
        this.last_data = this.data;
      }
      this.loading = false;
      setInterval(this.save.bind(this), 10000);
    }).catch(e => {
      this.show_error("无法读取速记本数据：" + this.error_text(e));
    });
  },
  beforeDestroy() {
    this.save();
  },
}
</script>

<style>
.notes h2 {
  text-align: center;
  font-size: 2rem !important;
}
.notes h3 {
  font-size: 1.8rem !important;
}
.notes h4 {
  font-size: 1.5rem !important;
}
.notes ul {
  list-style: disc;
  margin-left: 2rem;
}
.notes ol {
  list-style: decimal;
  margin-left: 2rem;
}
.toprow {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.history.button {
  margin-left: 1rem;
}
.history a.active {
  color: teal;
}
.history.data {
  margin: 13px 8px 13px 8px;
}
div.editor,div.history {
  max-width: 800px;
}
</style>

